import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {
    addFromColumn,
    copyObjectArray,
    toCurrency,
    sortArrayByKey,
    sortCurrency,
    addCommas
} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {setPriceValues, setProductCategories} from '../shared/reportFunctions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import ExpandableTableContainer from './ExpandableTableContainer';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import InventorySummaryIcon from 'material-ui/svg-icons/action/assignment';
import Config from '../messages';

/**
 * Settlement Reports class for retrieving and displaying Inventory Summary
 *
 */
class SettlementReportInventory extends Component {
    constructor(props) {
        super(props);
        const reportName = (props.reportType === 'pre-settlement') ? 'Pre-Settlement' : 'Settlement';
        this.state = {
            auditList: [],
            auditItemsChecked: false,
            auditItemsList: [],
            inventoryList: [],
            inventorySummaryList: [],
            message: null,
            priceList: [],
            reportName: reportName + ' Report Sales Summary',
            selectedZeroDay: null,
            summaryComplete: false,
            tableData: [],
            tableHeaders: [
                {label: 'Category', key: 'category'},
                {label: 'Product ID', key: 'productId'},
                {label: 'Description', key: 'description'},
                {label: 'Received', key: 'totalReceived'},
                {label: 'Sold', key: 'totalSold'},
                {label: 'Returns + Transfers + Adjustments', key: 'totalRTA'},
                {label: 'Remaining', key: 'totalRemaining'},
                {label: 'Counted', key: 'totalCounted'},
                {label: 'Variance', key: 'variance'},
                {label: 'Sell Price', key: 'sellPrice'},
                {label: 'Shrink Value', key: 'shrinkValue'},
                {label: 'Overage Value', key: 'overageValue'}
            ],
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
    }

    componentWillMount() {
        this.fetchDefaultPrices(this.props.location.productType);
        this.fetchInventoryByZeroDay(this.props.zeroDay);
    }

    componentWillReceiveProps(nextProps) {
        let clearTable = false;
        if (
            nextProps.location.id !== this.props.location.id ||
            nextProps.location.productType !== this.props.location.productType
        ) {
            clearTable = true;
            this.fetchDefaultPrices(nextProps.location.productType);
        }
        if (nextProps.zeroDay !== this.props.zeroDay) {
            clearTable = true;
            this.fetchInventoryByZeroDay(nextProps.zeroDay);
        }
        if (clearTable) {
            this.setState({
                errorMessage: null,
                inventorySummaryList: [],
                tableData: [],
                summaryComplete: false
            });
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get Prices for selected Location's Product Type
     *
     * @param productType
     */
    fetchDefaultPrices(productType) {
        // Assemble the URI
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "product_id", order: "ASC"},
            product_type: productType
        };
        const resource = reportsResources.DefaultPricesByProductType.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                const priceList = result.data.payload;
                this.setState({
                        priceList: priceList
                    },
                    () => this.generateInventorySummary(null, null, priceList)
                );
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                errorMessage: message,
                inventorySummaryList: [],
                summaryComplete: false,
                tableData: []
            }, () => {
                if (typeof this.props.onInventoryComplete === 'function') {
                    this.props.onInventoryComplete(true);
                }
                if (typeof this.props.onInventoryData === 'function') {
                    this.props.onInventoryData([]);
                }
            });
        });
    }

    /**
     * Get Inventory for selected Zero Day (for Inventory Summary)
     *
     * @param zeroDay
     */
    fetchInventoryByZeroDay(zeroDay) {
        // Assemble the URI
        const params = {
            filter: {},
            location_id: this.props.location.id.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: "type", order: "ASC"},
            zero_day: zeroDay
        };
        const resource = reportsResources.InventoryByZeroDay.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                this.processInventoryByZeroDayData(zeroDay, result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                    inventorySummaryList: [],
                    tableData: [],
                    summaryComplete: true
                }, () => {
                    if (typeof this.props.onInventoryComplete === 'function') {
                        this.props.onInventoryComplete(true);
                    }
                    if (typeof this.props.onInventoryData === 'function') {
                        this.props.onInventoryData([]);
                    }
                }
            );
        });
    }

    /**
     * Get Audits for selected Zero Day (for Inventory Summary)
     *
     * @param zeroDay
     */
    fetchFinalAuditsByZeroDay(zeroDay) {
        // Assemble the URI
        const params = {
            filter: {},
            location_id: this.props.location.id.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: "audit_uuid", order: "ASC"},
            zero_day: zeroDay
        };
        const resource = reportsResources.FinalAuditsByZeroDay.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                this.processFinalAuditsByZeroDayData(zeroDay, result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    }

    /**
     * Get Audit Items for selected Audit UUID (for Inventory Summary)
     *
     * @param auditUUID
     */
    fetchAuditItems(auditUUID) {
        // Assemble the URI
        const params = {
            filter: {},
            audit_uuid: auditUUID,
            location_id: this.props.location.id.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: "audit_uuid", order: "ASC"},
        };
        const resource = reportsResources.FinalAuditItems.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                this.processAuditItems(result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Store Inventory by Zero Day results (for Inventory Summary)
     *
     * @param zeroDay
     * @param list
     */
    processInventoryByZeroDayData(zeroDay, list) {
        let inventoryList = (list && list.length > 0) ? list : [];
        this.setState({
            inventoryList: inventoryList,
            selectedZeroDay: zeroDay
        });
        // Get Audits by Zero Day to populate additional columns
        this.fetchFinalAuditsByZeroDay(zeroDay);
    }

    /**
     * Process and store Audit results (for Inventory Summary)
     *
     * @param zeroDay
     * @param list
     */
    processFinalAuditsByZeroDayData(zeroDay, list) {
        let auditArray = [];
        let auditUUID = null;
        const length = list.length;
        let message = null;
        let reportType = this.props.reportType;
        if (list && length > 0) {
            for (let i = 0; i < length; i++) {
                const item = list[i];
                if (item.type === 'final') {
                    auditArray.push(item);
                }
            }
            // Select the latest Audit UUID in case there are multiples
            const sortField = (this.props.reportType === 'pre-settlement') ? 'start_time' : 'end_time';
            const sortedArray = sortArrayByKey(auditArray, sortField, 'DESC');
            auditUUID = sortedArray[0].audit_uuid;

            // If there is more than one Final Audit, display disclaimer text
            if (sortedArray.length > 1) {
                message = "Note: Each Location should have only one Final Audit. However, this Location has multiple Final Audits for the Date selected. Your numbers may vary.";
            }
            this.props.onDisplayMessage(message);

            this.setState({
                auditList: list,
                message: message
            });

            // Get Audit items for this Audit
            this.fetchAuditItems(auditUUID);
        } else if (length === 0 || reportType === 'pre-settlement') {
            // No Audit items exist, proceed
            let reportStr = (reportType === 'pre-settlement') ? 'Pre-Settlement Report' : 'Settlement Report';
            message = 'Note: No audit was performed on this ' + reportStr + ' for this Location. Any Inventory Summary below will not include audit items.';
            this.props.onDisplayMessage(message);
            this.setState({
                    auditItemsChecked: true,
                    auditItemsList: []
                },
                () => this.generateInventorySummary(null, [], null)
            );
        }
    }

    /**
     * Process and aggregate Audit Items
     *
     * @param list
     */
    processAuditItems = (list) => {
        let auditItems = [];
        list.forEach((item) => {
            const id = item.product;
            if (!auditItems[id]) {
                auditItems[id] = {
                    audit_uuid: item.audit_uuid,
                    product: item.product,
                    product_name: item.product_name,
                    qty: item.qty
                };
            } else {
                auditItems[id].qty = auditItems[id].qty + item.qty;
                if (auditItems[id].product_name !== item.product_name) {
                    auditItems[id].product_name = auditItems[id].product_name.concat(' / ', item.product_name);
                }
            }
        });

        this.setState({
                auditItemsChecked: true,
                auditItemsList: auditItems
            },
            () => this.generateInventorySummary(null, auditItems, null)
        );
    };

    /**
     * Update current table data based on sort
     *
     * @param event
     */
    handleSortChange(event) {
        const tableData = getTableState(this.reactTable);
        if (tableData && tableData.length > 0) {
            this.setState({
                tableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Building ------------------------------ */

    /**
     * Assemble values for Inventory Summary table
     *
     * @param iList
     * @param aList
     * @param pList
     */
    generateInventorySummary(iList, aList, pList) {

        // Create arrays for Inventory, Audit Items, and Prices
        let invList = (iList) ? copyObjectArray(iList) : copyObjectArray(this.state.inventoryList);
        let auditItemsList = (aList) ? aList : this.state.auditItemsList;
        let priceList = (pList) ? copyObjectArray(pList) : copyObjectArray(this.state.priceList);
        let summaryList = [];

        // Check if Audit Items list has been determined
        const auditItemsChecked = this.state.auditItemsChecked;

        if (invList.length > 0 && priceList.length > 0 && auditItemsChecked) {

            // Cycle through Inventory List for values
            const invLength = invList.length;
            for (let i = 0; i < invLength; i++) {
                const invItem = invList[i];
                if (invItem) {

                    // Create or update an Inventory Table Row item
                    const type = invItem.type;

                    // Do not include Final Audit Transfers (they will be in the Audit Items list)
                    if (type === 'final_audit_transfer') {
                        continue;
                    }

                    // Populate this row
                    const invIn = parseInt(invItem.inv_in, 10);
                    const invOut = parseInt(invItem.inv_out, 10);
                    const invInOut = invIn - invOut;
                    const productId = invItem.product.toString();
                    let totalReceived = 0;
                    let totalSold = 0;
                    let totalRTA = 0;
                    let rtaReturns = 0;
                    let rtaTransfers = 0;
                    let rtaAdjustments = 0;
                    let totalRemaining = 0;
                    let totalCounted = 0;
                    let variance = 0;
                    let sellPrice = '0.00';
                    let shrinkValue = '0.00';
                    let overageValue = '0.00';
                    let shrinkOverageMult = 0;

                    const invIdx = summaryList.findIndex(i => i.productId.toString() === productId);
                    if (invIdx === -1) {
                        // If this Product ID is not in the list, add it

                        totalReceived = (type === 'receive') ? invInOut : 0;
                        totalSold = (type === 'sale') ? invOut : 0;
                        rtaReturns = (type === 'return') ? invIn : 0;
                        rtaTransfers = (type === 'transfer') ? invInOut : 0;
                        rtaAdjustments = (type === 'admin_adjustment') ? invInOut : 0;
                        totalRTA = rtaReturns + rtaTransfers + rtaAdjustments;
                        totalRemaining = totalReceived - totalSold + totalRTA;

                        // Retrieve matching products from Audit Items list to calculate columns (total counted, variance)
                        variance = ((totalRemaining - totalCounted) * -1);
                        Object.entries(auditItemsList).forEach(entry => {
                            let [key, auditItem] = entry;
                            if (auditItem && key.toString() === invItem.product.toString()) {
                                totalCounted = auditItem.qty;
                                variance = ((totalRemaining - totalCounted) * -1);
                                // Override the title if the Audit item had been aggregated
                                if (auditItem.product_name !== invItem.product_name) {
                                    invItem.product_name = auditItem.product_name;
                                }
                            }
                        });

                        // Retrieve values from Prices list to calculate columns (sell price, overage/shrink values)
                        let prices = setPriceValues(this.props.location, productId, variance, priceList);
                        sellPrice = prices.sellPrice;
                        overageValue = prices.overageValue;
                        shrinkValue = prices.shrinkValue;

                        // Retrieve this Product's Category from the Price list
                        let cat = setProductCategories(productId, priceList);

                        // Assemble the inventory row
                        const summaryRow = {
                            category: cat.category,
                            categoryId: cat.categoryId,
                            description: invItem.product_name,
                            invIn: invIn,
                            invOut: invOut,
                            overageValue: overageValue,
                            productId: productId,
                            sellPrice: sellPrice,
                            shrinkValue: shrinkValue,
                            totalReceived: totalReceived,
                            totalSold: totalSold,
                            totalRTA: totalRTA,
                            rtaReturns: rtaReturns,
                            rtaTransfers: rtaTransfers,
                            rtaAdjustments: rtaAdjustments,
                            totalRemaining: totalRemaining,
                            totalCounted: totalCounted,
                            type: type,
                            variance: variance,
                        };
                        summaryList.push(summaryRow);

                    } else {

                        // If a row with this Product ID is already in the list, update its totals

                        const existingRow = summaryList[invIdx];
                        switch (type) {
                            case 'admin_adjustment':
                                existingRow.rtaAdjustments += invInOut;
                                break;
                            case 'receive':
                                existingRow.totalReceived += invInOut;
                                break;
                            case 'return':
                                existingRow.rtaReturns += invIn;
                                break;
                            case 'sale':
                                existingRow.totalSold += invOut;
                                break;
                            case 'transfer':
                                existingRow.rtaTransfers += invInOut;
                                break;
                            default:
                                break;
                        }

                        // Update this row's columns
                        existingRow.totalRTA = existingRow.rtaReturns + existingRow.rtaTransfers + existingRow.rtaAdjustments;
                        existingRow.totalRemaining = existingRow.totalReceived - existingRow.totalSold + existingRow.totalRTA;
                        existingRow.variance = ((existingRow.totalRemaining - existingRow.totalCounted) * -1);
                        shrinkOverageMult = (existingRow.sellPrice * existingRow.variance);
                        if (shrinkOverageMult === 0) {
                            existingRow.overageValue = '0.00';
                            existingRow.shrinkValue = '0.00';
                        } else if (shrinkOverageMult > 0) {
                            existingRow.overageValue = toCurrency(shrinkOverageMult);
                            existingRow.shrinkValue = '0.00';
                        } else if (shrinkOverageMult < 0) {
                            existingRow.overageValue = '0.00';
                            existingRow.shrinkValue = toCurrency(shrinkOverageMult);
                        }
                        if (existingRow.category === '') {
                            let cat = setProductCategories(productId, priceList);
                            existingRow.category = cat.category;
                            existingRow.categoryId = cat.categoryId;
                        }
                    }
                }
            }
        }

        // If any Audit Items have not been matched to an Inventory row,
        // or the Inventory list is empty (due to an Audit started without inventory), add them
        Object.entries(auditItemsList).forEach(entry => {
            let [key, auditItem] = entry;
                if (!invList.find(r => r.product.toString() === key.toString()) || !summaryList.find(r => r.productId === key)) {
                const auditItemProductId = auditItem.product.toString();
                let prices = setPriceValues(this.props.location, auditItemProductId, auditItem.qty, priceList);
                let cat = setProductCategories(auditItemProductId, priceList);
                const auditSummaryItem = {
                    category: cat.category,
                    categoryId: cat.categoryId,
                    description: auditItem.product_name,
                    invIn: 0,
                    invOut: 0,
                    overageValue: prices.overageValue,
                    productId: auditItemProductId,
                    sellPrice: prices.sellPrice,
                    shrinkValue: prices.shrinkValue,
                    totalReceived: 0,
                    totalSold: 0,
                    totalRTA: 0,
                    rtaReturns: 0,
                    rtaTransfers: 0,
                    rtaAdjustments: 0,
                    totalRemaining: 0,
                    totalCounted: auditItem.qty,
                    type: 'audit_item',
                    variance: auditItem.qty,
                };
                summaryList.push(auditSummaryItem);
            }
        });

        // Finalize Inventory Summary Table
        this.setState({
                inventorySummaryList: summaryList,
                tableData: summaryList,
                summaryComplete: true
            }, () => {
                if (typeof this.props.onInventoryComplete === 'function') {
                    this.props.onInventoryComplete(true);
                }
                if (typeof this.props.onInventoryData === 'function') {
                    this.props.onInventoryData(summaryList);
                }
            }
        );
    }

    /* Table Display ------------------------------ */

    render() {

        const {
            location,
            reportName,
            system,
            zeroDay
        } = this.props;

        const {
            inventorySummaryList,
            summaryComplete,
            tableData,
            tableHeaders
        } = this.state;

        const defaultSort = setDefaultTableSort('productId');

        const totalsStyle = {display: 'block'};

        // ReactTable headers, columns and footer totals for Inventory Summary

        const inventoryColumns = [
            {
                Header: 'Products',
                columns: [
                    {
                        Header: 'Category',
                        accessor: 'category',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        Footer: (<span style={{...tableStyles.footer, ...totalsStyle}}>&nbsp;</span>)
                    },
                    {
                        Header: 'Product ID',
                        accessor: 'productId',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        Footer: (<span style={{...tableStyles.footer, ...totalsStyle}}>&nbsp;</span>)
                    },
                    {
                        Header: 'Description',
                        accessor: 'description',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        headerStyle: tableStyles.thLast,
                        Footer: (<span style={{...tableStyles.footer, ...totalsStyle}}>Totals:</span>)
                    }
                ],
                headerClassName: 'th-min-220',
                style: tableStyles.thGroupMin
            },
            {
                Header: 'Customer Interactions',
                columns: [
                    {
                        Header: 'Total Received',
                        accessor: 'totalReceived',
                        Cell: row => (
                            <span>{addCommas(row.row.totalReceived)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'totalReceived'))}
                                </span>
                            )
                        })
                    },
                    {
                        Header: 'Total Sold',
                        accessor: 'totalSold',
                        Cell: row => (
                            <span>{addCommas(row.row.totalSold)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'totalSold'))}
                                </span>
                            )
                        })
                    },
                    {
                        Header: 'Total Returns, Transfers, & Adjustments',
                        accessor: 'totalRTA',
                        Cell: row => (
                            <span>{addCommas(row.row.totalRTA)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'totalRTA'))}
                                </span>
                            )
                        })
                    }
                ]
            },
            {
                Header: 'Calculations',
                columns: [
                    {
                        Header: 'Total Remaining',
                        accessor: 'totalRemaining',
                        Cell: row => (
                            <span>{addCommas(row.row.totalRemaining)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'totalRemaining'))}
                                </span>
                            )
                        })
                    },
                    {
                        Header: 'Total Counted',
                        accessor: 'totalCounted',
                        Cell: row => (
                            <span>{addCommas(row.row.totalCounted)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'totalCounted'))}
                                </span>
                            )
                        })
                    },
                    {
                        Header: 'Variance',
                        accessor: 'variance',
                        Cell: row => (
                            <span>{addCommas(row.row.variance)}</span>
                        ),
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {addCommas(addFromColumn(columnProps.data, 'variance'))}
                                </span>
                            )
                        })
                    },
                ]
            },
            {
                Header: 'Prices and Differences',
                columns: [
                    {
                        Header: 'Sell Price',
                        accessor: 'sellPrice',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (<span style={{...tableStyles.footer, ...totalsStyle}}>&nbsp;</span>)
                    },
                    {
                        Header: 'Shrink Value',
                        accessor: 'shrinkValue',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {toCurrency(addFromColumn(columnProps.data, 'shrinkValue'))}
                                </span>
                            )
                        })
                    },
                    {
                        Header: 'Overage Value',
                        accessor: 'overageValue',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (columnProps => {
                            return (
                                <span style={{...tableStyles.footer, ...totalsStyle}}>
                                    {toCurrency(addFromColumn(columnProps.data, 'overageValue'))}
                                </span>
                            )
                        })
                    }
                ]
            }
        ];

        return (
            <div>
                {!summaryComplete &&
                    <div className="loader-container">
                        <h4>Generating Inventory Summary...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }
                {summaryComplete &&
                    <div className="reports-table-container">

                        {/* Table Header: Inventory Summary */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container report-header-button-container">
                                {/* Export Inventory Summary */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={commonStyles.headerButton}
                                >
                                    <ExportIcon style={commonStyles.headerButtonIcon}/>
                                    <CSVLink
                                        data={tableData}
                                        headers={tableHeaders}
                                        filename={reportName + '-Inventory-Summary-' + system + '-' + location.id + '-' + zeroDay + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={commonStyles.headerButtonLink}
                                    >
                                        Export Inventory Summary
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <InventorySummaryIcon style={commonStyles.summaryIcon}/>
                                <span>Inventory Summary</span>
                            </h3>
                        </div>

                        {/* Table: Inventory Summary */}
                        <ExpandableTableContainer>
                            <ReactTable
                                key="table-inventory-summary"
                                data={inventorySummaryList}
                                columns={inventoryColumns}
                                defaultPageSize={1000}
                                defaultSorted={defaultSort}
                                filterable
                                defaultFilterMethod={filterCaseInsensitive}
                                onSortedChange={this.handleSortChange}
                                ref={(r) => this.reactTable = r}
                                showPagination={false}
                                resizable={false}
                                minRows={1}
                                className="-striped summary-table"
                            />
                        </ExpandableTableContainer>
                    </div>
                }
            </div>
        )
    }
}

SettlementReportInventory.propTypes = {
    addField: PropTypes.bool,
    location: PropTypes.object.isRequired,
    onDisplayMessage: PropTypes.func,
    onInventoryComplete: PropTypes.func,
    onInventoryData: PropTypes.func,
    reportName: PropTypes.string,
    reportType: PropTypes.string,
    system: PropTypes.string,
    zeroDay: PropTypes.string.isRequired
};

SettlementReportInventory.defaultProps = {
    addField: true,
    location: {
        dbaPriceLevel: null,
        id: null,
        name: null,
        priceLevel: null,
        productType: null
    },
    reportName: 'Settlement-Report',
    reportType: 'settlement',
    zeroDay: null
};

const enhance = compose(
    connect()
);

export default enhance(SettlementReportInventory);



// WEBPACK FOOTER //
// ./src/Fuse/components/SettlementReportInventory.js